import { watch, ref } from 'vue';
import { useAuth } from '../useAuth';
import { createStorageNamespace } from '@/modules/f8/hooks/storage/storage';

const defaultUserData = {
  cfgLang: 'en-EN',
  cfgTheme: 'light-blue',
  cfgDateFormat: 'DD.MM.YYYY',
  cfgShowHistory: false,
  cfgHistoryLimit: 10,
  cfgHistory: [],
  cfgSearchSeparator: '##',
};

const currentStorage = ref(null);
const auth = useAuth();

export function useUserStorage() {

  const user = ref(auth.getCurrentUserData());

  watch(
    user,
    (newUser) => {
      if (newUser?.id) {
        currentStorage.value = createStorageNamespace(newUser.id, defaultUserData);
      } else {
        currentStorage.value = createStorageNamespace('anonymous', defaultUserData);
      }
    },
    { immediate: true, deep: true }
  );

  return {
    get: (key, def) => currentStorage.value?.get(key, def),
    set: (key, val) => currentStorage.value?.set(key, val),
    ref: (key, def) => currentStorage.value?.ref(key, def),
    clear: () => currentStorage.value?.clear(),
    rawRef: () => currentStorage.value?.rawRef,
  };
}
